import { render, staticRenderFns } from "./resumeMessageOutside.vue?vue&type=template&id=b61a1d98&scoped=true"
import script from "./resumeMessageOutside.vue?vue&type=script&lang=js"
export * from "./resumeMessageOutside.vue?vue&type=script&lang=js"
import style0 from "./resumeMessageOutside.vue?vue&type=style&index=0&id=b61a1d98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61a1d98",
  null
  
)

export default component.exports